<template>
  <v-btn text icon
    :href="`mailto:${email}`"
    target="_blank"
  >
    <v-icon>mdi-at</v-icon>
  </v-btn>
</template>

<script>
export default {
  props: {
    email: {
      type: String,
      required: true,
    },
  },
}
</script>